export const ethnicities = {
  HISPANIC: {
    text: "Hispanic/Latino",
    value: "HISPANIC",
  },
  NON_HISPANIC: {
    text: "Non-Hispanic/Latino",
    value: "NON_HISPANIC",
  },
  unknown: {
    text: "Unknown",
    value: "UNKNOWN",
  },
};

export const eyeColors = {
  BROWN: {
    text: "Brown",
    value: "BROWN",
  },
  BLUE: {
    text: "Blue",
    value: "BLUE",
  },
  GREEN: {
    text: "Green",
    value: "GREEN",
  },
  OTHER: {
    text: "Other",
    value: "OTHER",
  },
};

export const hairColors = {
  BALD: {
    text: "Bald",
    value: "BALD",
  },
  BLACK: {
    text: "Black",
    value: "BLACK",
  },
  BLONDE: {
    text: "Blonde",
    value: "BLONDE",
  },
  BROWN: {
    text: "Brown",
    value: "BROWN",
  },
  GREY: {
    text: "Grey",
    value: "GREY",
  },
  RED: {
    text: "Red",
    value: "RED",
  },
  other: {
    text: "Other",
    value: "OTHER",
  },
};

export const races = {
  WHITE: {
    text: "White",
    value: "WHITE",
  },
  BLACK: {
    text: "Black",
    value: "BLACK",
  },
  ASIAN: {
    text: "Asian",
    value: "ASIAN",
  },
  NATIVE_AMERICAN: {
    text: "Native American",
    value: "NATIVE_AMERICAN",
  },
  UNKNOWN: {
    text: "Unknown",
    value: "UNKNOWN",
  },
};

export const sexes = {
  MALE: {
    text: "Male",
    value: "MALE",
  },
  FEMALE: {
    text: "Female",
    value: "FEMALE",
  },
  OTHER: {
    text: "Other",
    value: "OTHER",
  },
};

export const types = {
  DECEASED: {
    text: "Deceased",
    value: "DECEASED",
  },
  INTERVIEWED: {
    text: "Interviewed",
    value: "INTERVIEWED",
  },
  MISSING_RUNAWAY: {
    text: "Missing/Runaway",
    value: "MISSING_RUNAWAY",
  },
  PARENT_GUARDIAN: {
    text: "Parent/Guardian",
    value: "PARENT_GUARDIAN",
  },
  REPORTING_PERSON: {
    text: "Reporting person",
    value: "REPORTING_PERSON",
  },
  VICTIM: {
    text: "Victim",
    value: "VICTIM",
  },
  WITNESS: {
    text: "Witness",
    value: "WITNESS",
  },
  OTHER: {
    text: "Other",
    value: "OTHER",
  },
};
